import { render, staticRenderFns } from "./PersonalPropertyProduct.vue?vue&type=template&id=57b4a190"
import script from "./PersonalPropertyProduct.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports